import React, { useCallback, useEffect, useRef, useState } from "react";
import _ from "lodash";
import RGL, { WidthProvider, Layout } from "react-grid-layout";
import {
  Checkbox,
  createStyles,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { CustomTheme } from "../../../../types/customTheme";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import DashboardCreateModal from "./DashboardCreateModal";
import CardCommon from "../../../../components/card/CardCommon";
import WidgetDetailsModal from "./WidgetDetailsModal";
import WithLoading from "../../../../utils/WithLoading";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import { useRouteMatch } from "react-router-dom";
import ConfigDetailsModal from "./ConfigDetailsModal";


const useStyles = makeStyles((theme: CustomTheme) => createStyles({}));

interface DynamicMinMaxLayoutProps {
  stationNode: any;
  layoutDetails: any;
  setLayoutDetails: any;
  isLoading: any;
  clientId: any;
  locationSelectorList: any;
}

const MetricsNode: React.FC<DynamicMinMaxLayoutProps> = ({
  stationNode,
  layoutDetails,
  setLayoutDetails,
  isLoading,
  clientId,
  locationSelectorList,
}) => {
  const [isOpenDashboardCreateModal, setIsOpenDashboardCreateModal] =
    useState(false);
  const [isOpenDashboardWidgetModal, setIsOpenDashboardWidgetModal] =
    useState(false);
  const [isOpenWidgetSelectionModal, setIsOpenWidgetSelectionModal] =
    useState(false);
  const [isOpenConfigDetailsModal, setIsOpenConfigDetailsModal] =
    useState(false);
  const [configDetails, setConfigDetails] = useState<any>({});
  const [selectedWarningType, setSelectedWarningType] = useState({
    id: "box",
    label: "Box",
  });
  const [selectedLocationId, setSelectedLocationId] = useState({});
  const [selectedCriticalType, setSelectedCriticalType] = useState({
    id: "box",
    label: "Box",
  });
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [success, setSuccess] = useState("");

  const match: any = useRouteMatch();
  const locationId = match?.params?.locationId;

  const [dashboardName, setDashboardName] = useState("");
  const [widgetId, setWidgetId] = useState("");
  const [editDetails, setEditDetails] = useState<any>({});

  const handleCreateNewDashboard = () => {
    setIsOpenDashboardCreateModal(true);
  };
  const handleEdit = (key: any) => {
    setEditDetails(layoutDetails[key]);
    setConfigDetails(layoutDetails[key]?.config || {});
    setDashboardName(layoutDetails[key].name);
    setIsOpenDashboardWidgetModal(true);
    setWidgetId(key);
  };

  const handleCopyClick = async (api_key: any) => {
    try {
      const domain = window.location.hostname;
      await navigator.clipboard.writeText(
        `${domain}/${locationId}/presto-insight/public/${api_key}`,
      );
      setSuccess("Copied!");
    } catch (err) {
      setSuccess("Failed to copy!");
    }
  };

  const handleOpenConfigDetails = () => {
    setIsOpenConfigDetailsModal(true);
    const criticalType = editDetails?.config?.criticalType || "box";
    const capitalizedLabel =
      criticalType.charAt(0).toUpperCase() + criticalType.slice(1);

    setSelectedCriticalType({ id: criticalType, label: capitalizedLabel });
    setIsDarkMode(editDetails?.config?.isDarkMode ?? false);

    const warningType = editDetails?.config?.warningType || "box";
    const capitalizedWarningTypeLabel =
      warningType.charAt(0).toUpperCase() + warningType.slice(1);

    setSelectedWarningType({
      id: warningType,
      label: capitalizedWarningTypeLabel,
    });


  };

  return (
    <>
      <div
        style={{ display: "flex", justifyContent: "end", marginBottom: "20px" }}
      >
        <ButtonCommon
          onClick={handleCreateNewDashboard}
          style={{ width: "250px" }}
        >
          Create New Dashboard
        </ButtonCommon>
      </div>
      <DashboardCreateModal
        open={isOpenDashboardCreateModal}
        setOpen={setIsOpenDashboardCreateModal}
        setIsOpenDashboardWidgetModal={setIsOpenDashboardWidgetModal}
        dashboardName={dashboardName}
        setDashboardName={setDashboardName}
        setLayoutDetails={setLayoutDetails}
        setWidgetId={setWidgetId}
      />
      <ConfigDetailsModal
        open={isOpenConfigDetailsModal}
        setOpen={setIsOpenConfigDetailsModal}
        selectedWarningType={selectedWarningType}
        setSelectedWarningType={setSelectedWarningType}
        selectedCriticalType={selectedCriticalType}
        setSelectedCriticalType={setSelectedCriticalType}
        configDetails={editDetails?.config || {}}
        setIsDarkMode={setIsDarkMode}
        isDarkMode={isDarkMode}
      />
      <WidgetDetailsModal
        open={isOpenDashboardWidgetModal}
        setOpen={setIsOpenDashboardWidgetModal}
        stationNode={stationNode}
        setIsOpenWidgetSelectionModal={setIsOpenWidgetSelectionModal}
        isOpenWidgetSelectionModal={isOpenWidgetSelectionModal}
        dashboardName={dashboardName}
        widgetId={widgetId}
        handleOpenConfigDetails={handleOpenConfigDetails}
        editDetails={editDetails}
        setEditDetails={setEditDetails}
        setLayoutDetails={setLayoutDetails}
        setDashboardName={setDashboardName}
        selectedWarningType={selectedWarningType}
        selectedCriticalType={selectedCriticalType}
        configDetails={configDetails}
        isDarkMode={isDarkMode}
        clientId={clientId}
        selectedLocationId={selectedLocationId}
        locationSelectorList={locationSelectorList}
        setSelectedLocationId={setSelectedLocationId}
      />

      <Grid container spacing={2}>
        {Object.entries(layoutDetails).map(([key, value]: any) => (
          <Grid item xs={6}>
            <CardCommon backgroundColor={"entity_background"}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingLeft: "12px",
                }}
              >
                <Typography
                  align="left"
                  style={{
                    height: "60px",
                    display: "flex",
                    alignItems: "center",
                  }}
                  variant="h6"
                >
                  {value.name}
                </Typography>

                <div style={{ paddingRight: "12px" }}>
                  <ButtonCommon color="yellow" onClick={() => handleEdit(key)}>
                    <EditIcon />
                  </ButtonCommon>
                  <ButtonCommon
                    color="blue"
                    style={{ marginLeft: "12px" }}
                    onClick={() => {
                      handleCopyClick(key);
                    }}
                  >
                    <FileCopyIcon />
                  </ButtonCommon>
                </div>
              </div>
            </CardCommon>
          </Grid>
        ))}
      </Grid>

      <DefaultAlert
        open={!!success}
        handleClose={() => setSuccess("")}
        message={success}
        severity={"success"}
      />
    </>
  );
};

export default WithLoading(MetricsNode);
